export type RoleInfo = {
  name: string;
};

type PermissionScope = 'GLOBAL' | 'PROJECT';

export const MODULE_SCOPE: Record<string, PermissionScope> = {
  projects: 'PROJECT',
  surveys: 'PROJECT',
  surveySets: 'PROJECT',
  notifications: 'PROJECT',
  faqs: 'GLOBAL',
  wallets: 'GLOBAL',
  users: 'GLOBAL',
};

export const getGlobalRole = (): string => {
  try {
    const data = localStorage.getItem('roleInfo');
    return data ? JSON.parse(data)?.name : '';
  } catch {
    return '';
  }
};

export const getProjectRole = (projectId: number): string => {
  try {
    const data = localStorage.getItem('projectRoles');
    if (!data) return '';
    return JSON.parse(data)?.[projectId] ?? '';
  } catch {
    return '';
  }
};
